// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, func, object, oneOfType, string } from 'prop-types'
import Radio from './Radio'
import ErrorSimple from './ErrorSimple'

const RadioGroup = props => {
  const {
    className,
    disabled,
    idRoot,
    input,
    label,
    meta,
    onChangeCustom,
    onClickCustom,
    options,
  } = props

  return (
    <div className={className}>
      { label && <label id={`${idRoot}-label`}>{label}</label> }
      <div className={'radio-group display-flex flex-direction-row justify-content-around center-text'}>
        {options.map(o => (
          <Radio
            key={`${idRoot}-${o.value}`}
            input={input}
            disabled={disabled}
            {...o}
            onChangeCustom={onChangeCustom}
            onClickCustom={onClickCustom}
            id={`${idRoot}-${o.value}`} />
        ))}
      </div>
      <ErrorSimple
        error={meta.error}
        idRoot={idRoot} />
    </div>
  )
}

RadioGroup.propTypes = {
  className: string,
  disabled: bool,
  idRoot: string.isRequired,
  input: object.isRequired,
  label: oneOfType([
    string,
    object,
  ]),
  meta: object.isRequired,
  onChangeCustom: func,
  onClickCustom: func,
  options: array.isRequired,
}

export default RadioGroup
